import SHAREBOX_I32_CHECK_IN_STEPS from './i32';

const SHAREBOX_W64_CHECK_IN_STEPS = SHAREBOX_I32_CHECK_IN_STEPS;

export default SHAREBOX_W64_CHECK_IN_STEPS;
